import RelationshipType from "./RelationshipType.mjs";
import Person from "./Person.mjs";
import Self from "./Self.mjs";
export default class FamilyMember extends Person {
    constructor(name, relationshipType, gender, alive) {
        if (relationshipType == RelationshipType.SELF) {
            throw new Error("Enum Relationship.SELF can only be set on instance of Self");
        }
        super(name, relationshipType, gender, alive);
    }
    addMother(mother) {
        super.addMother(mother);
        if (Self.get()._mother != mother)
            Self.get().addNonImmediateRelative(mother);
    }
    addFather(father) {
        super.addFather(father);
        if (Self.get()._father != father)
            Self.get().addNonImmediateRelative(father);
    }
    addSon(son) {
        super.addSon(son);
        Self.get().addNonImmediateRelative(son);
    }
    addDaughter(daughter) {
        super.addDaughter(daughter);
        Self.get().addNonImmediateRelative(daughter);
    }
}
